import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="footer">

      {/* Main content */}
      <div className="top">
        <div className="container">
          <div className="footer-main">

            {/* Logo + tagline */}
            <div className="footer-brand">
              <div className="logo">
                <img src={`${process.env.PUBLIC_URL}/img/logo.png`} alt="Black Rock Hotel" />
              </div>
              <p>A serene sanctuary where comfort, culture, and nature unite at the shores of Khuvsgul Lake.</p>
              <div className="social-icons">
                <ul className="list-inline">
                  <li><a href="https://www.instagram.com/blackrock.mn" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-instagram"></i></a></li>
                  <li><a href="https://www.facebook.com/BlackRockMongolia" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-facebook-f"></i></a></li>
                </ul>
              </div>
            </div>

            {/* Vertical divider */}
            <div className="footer-divider" />

            {/* Contact */}
            <div className="footer-contact">
              <h3>Contact</h3>
              <div className="footer-contact__row">
                <i className="fa-thin fa-location-dot"></i>
                <span>East Shore of Khuvsgul Lake, 1st Bag,<br />Chandmani-Undur Soum, Khuvsgul Province, Mongolia</span>
              </div>
              <div className="footer-contact__row">
                <i className="fa-thin fa-phone"></i>
                <a href="tel:+97675100111">+976 75100111</a>
              </div>
              <div className="footer-contact__row">
                <i className="fa-thin fa-envelope"></i>
                <a href="mailto:info.blackrock@rrc.mn">info.blackrock@rrc.mn</a>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="bottom">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8 col-md-12">
              <div className="links">
                <ul>
                  <li><Link to="/policies">Terms & Policies</Link></li>
                  <li><Link to="/contact">Contact Us</Link></li>
                </ul>
              </div>
            </div>
            <div className="col-lg-4 col-md-12 text-end">
              <p>© 2026 Black Rock Hotel · <a href="https://onlinemongols.com/" target="_blank" rel="noopener noreferrer">Online Mongols</a></p>
            </div>
          </div>
        </div>
      </div>

    </footer>
  );
}

export default Footer;
